import type { ApiResponse } from "../../../shared/types/api";
import type {
  MachineProductEntity,
  CreateMachineProductRequest,
  UpdateMachineProductRequest,
} from "../../../domain/types/machine-product";
import type { UnreportedMachineProductEntity } from "../../../domain/types/unreported-machine-product";
import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";

class AdminMachineProductApiService {
  async getAll(): Promise<ApiResponse<MachineProductEntity[]>> {
    const response = await httpClient.get<
      ApiResponse<MachineProductEntity[]>
    >(NEW_API_ENDPOINTS.adminMachineProductController.GET_ALL);

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "장비 제품 목록 조회 실패");
    }

    return response.data;
  }

  async getById(id: number): Promise<ApiResponse<MachineProductEntity>> {
    const response = await httpClient.get<
      ApiResponse<MachineProductEntity>
    >(NEW_API_ENDPOINTS.adminMachineProductController.GET_BY_ID(id));

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "장비 제품 상세 조회 실패");
    }

    return response.data;
  }

  async create(
    request: CreateMachineProductRequest
  ): Promise<ApiResponse<MachineProductEntity>> {
    const response = await httpClient.post<
      ApiResponse<MachineProductEntity>
    >(NEW_API_ENDPOINTS.adminMachineProductController.CREATE, request);

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "장비 제품 생성 실패");
    }

    return response.data;
  }

  async update(
    id: number,
    request: UpdateMachineProductRequest
  ): Promise<ApiResponse<MachineProductEntity>> {
    const response = await httpClient.put<
      ApiResponse<MachineProductEntity>
    >(NEW_API_ENDPOINTS.adminMachineProductController.UPDATE(id), request);

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "장비 제품 수정 실패");
    }

    return response.data;
  }

  async delete(id: number): Promise<ApiResponse<boolean>> {
    const response = await httpClient.delete<ApiResponse<boolean>>(
      NEW_API_ENDPOINTS.adminMachineProductController.DELETE(id)
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "장비 제품 삭제 실패");
    }

    return response.data;
  }

  async getAllUnreported(): Promise<
    ApiResponse<UnreportedMachineProductEntity[]>
  > {
    const response = await httpClient.get<
      ApiResponse<UnreportedMachineProductEntity[]>
    >(NEW_API_ENDPOINTS.adminMachineProductController.GET_ALL_UNREPORTED);

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "미보고 장비 목록 조회 실패");
    }

    return response.data;
  }

  async getUnreportedById(
    id: number
  ): Promise<ApiResponse<UnreportedMachineProductEntity>> {
    const response = await httpClient.get<
      ApiResponse<UnreportedMachineProductEntity>
    >(NEW_API_ENDPOINTS.adminMachineProductController.GET_UNREPORTED_BY_ID(id));

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "미보고 장비 상세 조회 실패");
    }

    return response.data;
  }
  async deleteUnreported(id: number): Promise<ApiResponse<boolean>> {
    const response = await httpClient.delete<ApiResponse<boolean>>(
      NEW_API_ENDPOINTS.adminMachineProductController.DELETE_UNREPORTED(id)
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "미보고 장비 삭제 실패");
    }

    return response.data;
  }
}

export const adminMachineProductApiService =
  new AdminMachineProductApiService();